<template>
  <div
    class="gray-lighten-2 space-y-2 rounded-md p-2"
    :class="{ 'opacity-50': !knownBusinessEntityContact.isActive }"
  >
    <div
      class="flex items-center gap-x-2"
      :title="isAvailable ? 'Nu beschikbaar' : 'Nu niet beschikbaar'"
    >
      <span class="size-4 rounded-full" :class="isAvailable ? 'bg-success' : 'bg-error'" />
      <div class="flex flex-col">
        <span class="text-sm select-none">{{ knownBusinessEntityContact.person.fullName }}</span>
        <span class="text-sm font-semibold select-none">
          {{ knownBusinessEntityContact.knownBusinessEntityName }}
        </span>
      </div>
    </div>

    <AvailabilityFormBase
      :availability-bucket="knownBusinessEntityContact.availabilityBucket"
      :disabled="!knownBusinessEntityContact.isActive"
    />
    <AvailabilityFormWeekly
      :availability-bucket="knownBusinessEntityContact.availabilityBucket"
      :disabled="!knownBusinessEntityContact.isActive"
    />
    <AvailabilityFormUnavailability
      v-model="knownBusinessEntityContact.availabilityBucket.availabilityBlocks"
      :entity-table="KnownBusinessEntityContact.className"
      :availability-bucket="knownBusinessEntityContact.availabilityBucket"
      :disabled="!knownBusinessEntityContact.isActive"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useMinuteClock } from "@/composables/utils/use-minute-clock.ts"
import AvailabilityFormBase from "@/components/availability/form/AvailabilityFormBase.vue"
import AvailabilityFormWeekly from "@/components/availability/form/AvailabilityFormWeekly.vue"
import AvailabilityFormUnavailability from "@/components/availability/form/AvailabilityFormUnavailability.vue"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { KnownBusinessEntityContactAvailabilityHelper } from "@/helper/models/known-business-entity-contact-availability-helper.ts"

const knownBusinessEntityContact = defineModel<KnownBusinessEntityContact>({ required: true })

const now = useMinuteClock() // Updates the moment every minute so the availability is updated in real-time.

const isAvailable = computed(() =>
  KnownBusinessEntityContactAvailabilityHelper.isAvailableAtMoment(
    knownBusinessEntityContact.value!.availabilityBucket,
    now.value
  )
)
</script>
